"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__FOR_TESTING__resetDeprecationsSeen = exports.ofType = exports.combineEpics = exports.StateObservable = exports.createEpicMiddleware = void 0;
var createEpicMiddleware_1 = require("./createEpicMiddleware");
Object.defineProperty(exports, "createEpicMiddleware", { enumerable: true, get: function () { return createEpicMiddleware_1.createEpicMiddleware; } });
var StateObservable_1 = require("./StateObservable");
Object.defineProperty(exports, "StateObservable", { enumerable: true, get: function () { return StateObservable_1.StateObservable; } });
var combineEpics_1 = require("./combineEpics");
Object.defineProperty(exports, "combineEpics", { enumerable: true, get: function () { return combineEpics_1.combineEpics; } });
var operators_1 = require("./operators");
Object.defineProperty(exports, "ofType", { enumerable: true, get: function () { return operators_1.ofType; } });
// eslint-disable-next-line camelcase
var console_1 = require("./utils/console");
Object.defineProperty(exports, "__FOR_TESTING__resetDeprecationsSeen", { enumerable: true, get: function () { return console_1.resetDeprecationsSeen; } });



//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/dist/cjs/index.js
// module id = 706
// module chunks = 0